<div class="card" style="padding: 0.25rem">
    <button type="button" class="layout-topbar-action" (click)="showDialog('topright')">
        <i class="pi pi-user"></i>
        <span>{{ 'common.profile' | translate }}</span>
    </button>

    <p-dialog [showHeader]="false" [(visible)]="visible" [position]="position" [closable]="true"
        [style]="{ width: '15rem', marginTop: '5rem' }" [modal]="false">
        <h5 style="margin-top: 1rem; text-align: center;">Benutzermenü</h5>
        <div class="flex flex-col justify-end gap-2 mt-1">
            <p-button class="**:w-full flex justify-center" label="Profil" icon="pi pi-user" iconPos="left"
                severity="secondary" (click)="goToProfile()" />
            <p-button *ngIf="user.roles?.includes('administration')" class="**:w-full flex justify-center"
                label="Profil bearbeiten" icon="pi pi-user-edit" iconPos="left" severity="secondary"
                (click)="goToProfileEdit()" />
            <p-button *ngIf="user.roles?.includes('administration') || user.isSystemAdmin" class="**:w-full flex justify-center" label="Admin"
                icon="pi pi-wrench" iconPos="left" severity="secondary" (click)="goToAdminPage()" />
            <p-button class="**:w-full flex justify-center" label="Abmelden" icon="pi pi-sign-out" iconPos="left"
                severity="secondary" (click)="logout()" />
        </div>
    </p-dialog>
</div>
